// extracted by mini-css-extract-plugin
module.exports = {"root":"_32TES5TC","background":"uwhh6fac","title":"rpwYAvTs","subtitle":"RthE0_xj","light":"ZJ_gnStE","overlay":"KW7rzAtF"};